import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Title, Wrapper } from './styled';
import { Desktop, Mobile } from '../../components/MediaQuery';

const isMiracleProjectCountry = country => {
  return country === 'CA' || country === 'US';
};

class Banner extends Component {
  showText(freeShipping, country) {
    if (isMiracleProjectCountry(country)) {
      return (
        <>
          SUPPORT CHILDREN IN NEED: <u style={{ fontFamily: 'Avenir Black', textDecoration: 'underline' }}>LEARN HOW</u>
        </>
      );
    }

    if (freeShipping) {
      return 'FREE SHIPPING ON 150,000+ PRODUCTS!';
    }

    return '150,000+ NEW AND AUTHENTIC PRODUCTS!';
  }

  render() {
    const { country, freeShipping } = this.props;
    return (
      <>
        <Mobile>
          <Wrapper data-cy="top-banner" className="ub-miracle-project-mobile">
            <Title cursor={isMiracleProjectCountry(country)}>{this.showText(freeShipping, country)}</Title>
          </Wrapper>
        </Mobile>
        <Desktop>
          <Wrapper data-cy="top-banner" className="ub-miracle-project-desktop">
            <Title cursor={isMiracleProjectCountry(country)}>{this.showText(freeShipping, country)}</Title>
          </Wrapper>
        </Desktop>
      </>
    );
  }
}

Banner.propTypes = {
  freeShipping: PropTypes.bool,
  shop: PropTypes.bool,
  custom: PropTypes.string,
  desktop: PropTypes.bool,
  mobile: PropTypes.bool,
};

export default Banner;
